import React, { Component } from "react";
import {  Loader, Icon, Message, Tab, Header, Form, Table, Select, Input, Dropdown, List, Button, Modal, Divider, Checkbox} from 'semantic-ui-react'
import { invokeApig, downloadS3Text, uploadS3Text } from "../libs/awsLib";
import config from "../config";
import { alertCodes } from "../metadata/AlertCodes";
import JSONDataEntry from "./JSONDataEntry";
import { exporttoJSON } from "../libs/sharedFunctions";
import _ from 'lodash';


export default class AlertConfigurations extends Component {
  constructor(props) {
    super(props);

    var jsonFormat={
      "type": "object", "label": "Alert Configuration", 
      "fields": {
          "suppressDuplicateAlertMessages": {"label": "Suppress Duplicate Alert Messages?", "type": "bit", "nullable": false, "toggle": true},
          "suppressDuplicateCriticalAlertMessages": {"label": "Suppress Duplicate Critical Alert Messages?", "type": "bit", "nullable": false, "toggle": true},
        }}
    
        var newConfigurationTemplate={
          "suppressDuplicateAlertMessages": true,    
          "suppressDuplicateCriticalAlertMessages": true,    
        }
        

      Object.keys(alertCodes).forEach(alertCode=>{

        jsonFormat.fields[alertCode]={"label": alertCode + ' - ' + alertCodes[alertCode].description, "type": "varchar", "lookupvalues": {"Ignore": "Ignore", "RaiseAlertMessage": "Raise Alert Message", "RaiseCriticalAlertMessage": "Raise Critical Alert Message"}, "nullable": true}
        newConfigurationTemplate[alertCode]=(alertCodes[alertCode].critical ? "RaiseCriticalAlertMessage" : "RaiseAlertMessage");

      });


    this.state={alertConfigurations: {}, tabIndex: 0, uploadSuccess: false, uploadFailed: false, showAddNewModal: false, newConfigurationName: null, configToCopy: 'blank', jsonFormat: jsonFormat, newConfigurationTemplate: newConfigurationTemplate, filepath: null, loading: true};

  }


  
  componentDidMount ()
  {
    this.loadContent();
  }

  // loadJSONFormat()
  // {
  //   invokeApig({path: "/lookups/alertConfiguration/definition", method: "GET",  body: null}).then(result=>{

  //     this.setState({jsonFormat: result.data.jsonformat});
  //     })
  // }

  addAlertConfiguration(name)
  {
    var copyData=_.cloneDeep(this.state.alertConfigurations);
    copyData[name]=this.state.newConfigurationTemplate;
    this.setState({alertConfigurations: copyData})
  }

  updateAlertConfiguration(name, data)
  {
    var copyData= _.cloneDeep(this.state.alertConfigurations);
    copyData[name]=_.cloneDeep(data);
    this.setState({alertConfigurations: copyData})
  }


  deleteAlertConfiguration(alertConfiguration)
  {
    var copyData=_.cloneDeep(this.state.alertConfigurations);
    delete copyData[alertConfiguration]
    this.setState({alertConfigurations: copyData})
  }

  loadContent()
  {
    const bucket=config.awsEnv+'.sgserve.config';
    const key=config.stage+'/alertconfigurations.json'
    downloadS3Text(bucket, key).then(result=>{console.log(result); this.setState({alertConfigurations: result, loading: false})})
  }
  saveContent()
  {
    const bucket=config.awsEnv+'.sgserve.config';
    const key=config.stage+'/alertconfigurations.json'
    //update json 
    uploadS3Text(bucket, key, this.state.alertConfigurations).then(result=>{this.setState({uploadSuccess: true, uploadFailed: false, validationErrors: []})}).catch(result=>{this.setState({uploadSuccess: false, uploadFailed: true, validationErrors: ['Failed to save alert configurations file']})})
  }

  closeAddNewModal=()=>
  {
    this.setState({showAddNewModal: false, configToCopy: null, newConfigurationName: null})
  }
 

  handleChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
  }


  addNewAlertConfiguration()
  {
    //check the name is different
    if (this.state.newConfigurationName !== null && this.state.newConfigurationName !== "")
        {
          if (this.state.newConfigurationName in this.state.alertConfigurations)
            alert("Device configuration name already exists")
        else {
          // if select (dropdown) is not blank/create blank
          if (this.state.configToCopy === null)
          alert("Create a new configuration or select an existing configuration to use as a template")
          else {
            if (this.state.configToCopy === 'blank'){
                this.addAlertConfiguration(this.state.newConfigurationName);
                this.setState({showAddNewModal: false});
                this.closeAddNewModal();
              }
            else
            {
              // copy data from the selected policy
              var copyData=_.cloneDeep(this.state.alertConfigurations);
              var copyConfig=this.state.alertConfigurations[this.state.configToCopy];
              copyData[this.state.newConfigurationName]=_.cloneDeep(copyConfig);
              this.setState({alertConfigurations: copyData})
              this.closeAddNewModal();
            }
          }
        }
         }
    else alert("Please provide an alert configuration name")

  }


 render() {
  const handleTabChange=(e, data)=>
  {

    //handle add new click
    if (data.activeIndex===Object.keys(this.state.alertConfigurations).length)
    {
      this.setState({showAddNewModal: true})
    }
    this.setState({tabIndex: data.activeIndex})
  }

        var alertConfigurations=[{key: 0, text: 'New Device Configuration', value: 'blank'}]
        Object.keys(this.state.alertConfigurations).forEach((alertConfiguration, i)=>alertConfigurations.push({key: i+1, text: alertConfiguration, value: alertConfiguration}))
     
        const panes = Object.keys(this.state.alertConfigurations).map(alertConfigurationname=>{
          var alertConfiguration=this.state.alertConfigurations[alertConfigurationname];
          return { menuItem: {key: alertConfigurationname, content: alertConfigurationname, icon: 'wrench'}, render: () => <Tab.Pane>
        <div>
        <JSONDataEntry jsonformat={this.state.jsonFormat} data={alertConfiguration} editmode={true} onDataChange={newData=>{this.updateAlertConfiguration(alertConfigurationname, newData)}} darkmode={this.props.darkmode}/>
        </div>
        </Tab.Pane> }
        });
        panes.push({ menuItem: {key: "Add", content: "Add New", icon: 'add'}, render: ()=><Tab.Pane></Tab.Pane>})
      if (this.state.loading)
        return <Loader/>
      else 
        return (
      <div>
      <div className="fullpagetab">
      <div>
      <Tab  grid= {{paneWidth: 13, tabWidth: 3}} menu={{tabular: false, fluid: true, vertical: true, className: this.props.darkmode ? "seaglassblueinverted-darkmode viewtabmenu" : "seaglassblueinverted viewtabmenu", inverted: true }} activeIndex={this.state.tabIndex} panes={panes} onTabChange={handleTabChange} />
      </div>
      {this.state.uploadFailed && <Message error header="Failed to save alert configurations" list={this.state.validationErrors}/>}
      {this.state.uploadSuccess && <Message success header="Alert configurations successfully saved"/>}
      <Modal open={this.state.showAddNewModal}>
        <Modal.Header size='tiny'>
          <h3 className="seaglassblue"><Icon circular className="seaglassblue" name="add" onClick={this.addNewPolicy}/>Add New Alert Configuration</h3>
        </Modal.Header>  
        <Modal.Content>
        <Form>
        <Form.Input
          id="newConfigurationName"
          label="Alert Configuration Name"
          fluid
          required
          placeholder='Alert Configuration Name'
          value={this.state.newConfigurationName}
          onChange={this.handleChange}
        />
        <Form.Select label="Alert Configuration to Copy" placeholder="Alert Configuration to Copy" required options={alertConfigurations} onChange={(event, data)=>{this.setState({configToCopy: data.value})}}></Form.Select>
        <Divider/>
        {this.state.components && <Button className="seaglassbutton" disabled={!this.state.formValid || this.state.submitSuccess} loading={this.state.isExecuting} onClick={this.executeFunction}>Save</Button>}
        <Button className='seaglassbutton' onClick={()=>this.addNewAlertConfiguration()}>Add</Button>
        <Button className="seaglassbutton" onClick={this.closeAddNewModal}>Close</Button>
        </Form>
        </Modal.Content>
        </Modal>   
      <div>
      <Button className='seaglassbutton' onClick={()=>this.saveContent()}>Save</Button>
      <Button className='seaglassbutton' onClick={()=>this.loadContent()}>Reset</Button>
      </div>
      </div>
      </div>
    
    );  

  
    }
  }